import { evaluateResponseErrorCode, getApiError } from '../../errors';
import { post } from '../../http';

export type MlifeAccountSetupRequest = {
  firstName: string;
  lastName: string;
  dob: string;
  login: string;
  primaryPhone: string;
  activationKid: string;
  credentials: {
    password: string;
  };
  address: {
    street: string;
    city: string;
    state: string;
    postalCode: string;
    country: string;
  };
  canadianOptIn?: boolean;
  partner?: { name: string; tokenKey: string };
};

export const mlifeAccountSetupRequest = async (requestBody: MlifeAccountSetupRequest) => {
  try {
    const result = await post('/guest?activateMlife=true', {
      body: JSON.stringify(requestBody),
    });

    evaluateResponseErrorCode(result.response);

    return result.response;
  } catch (error) {
    throw getApiError(error);
  }
};
